@if (week) {
  <div class="week-trips">
    <div class="trips-head">
      <h6>{{ 'tracking.trips.title' | translate }}</h6>
      @if (week.vehicle === 'lease') {
        <span class="hint">{{ 'tracking.trips.lease' | translate }}</span>
      }
      @if (!userId || auth.isAdmin) {
        <button nbButton ghost size="small" class="overview" (click)="openOverview()">
          <nb-icon icon="download-outline"></nb-icon>
          {{ 'tracking.trips.overview' | translate }}
        </button>
      }
    </div>
    @if (!userId && week.vehicle === 'none') {
      <p class="state-hint">{{ 'tracking.trips.novehicle' | translate }}
        @if (auth.isAdmin) { <a routerLink="/users/me">{{ 'tracking.trips.novehicle_admin' | translate }}</a> }
      </p>
    }

    @if (!narrow) {
      <!-- Hours Calendar look (timesheet.component.html, desktop calendar): a header card with the
           days and day totals, then one card per travel type or project. The arrows emit (paged); the Km page pages. -->
      <div class="calendar-block">
        <ng-container *ngTemplateOutlet="calHeader"></ng-container>

        <div class="calendar-body">
          @if (!groups.length && !form) {
            <p class="empty">{{ 'tracking.trips.empty' | translate:{week: weekNumber} }}</p>
          }
          @for (g of groups; track g.key) {
            @let title = g.kind === 'project' ? g.name : ((g.kind === 'commute' ? 'tracking.trips.commute' : 'tracking.trips.other_trips') | translate);
            @let open = !closed.has(g.key);
            <div class="calendar-project" [attr.data-group]="g.key">
              <div class="calendar-project-header">
                <div class="side">
                  <button class="open-button" nbButton [status]="open ? 'primary' : 'basic'" size="small" shape="round" [disabled]="!!form"
                          [attr.aria-expanded]="open" [attr.aria-label]="title" (click)="toggle(g.key)">
                    <nb-icon [icon]="open ? 'arrow-down' : 'arrow-right'"></nb-icon></button>
                  <span class="proj-dot" [style.background-color]="g.color || 'transparent'"></span>
                  <span class="title-item">{{ title }}</span>
                  @if (g.client) { <span class="client-item">{{ g.client }}</span> }
                </div>
                <blockquote></blockquote>
                @for (km of g.days; track $index) { <div class="group-day">{{ fmt(km || null) }}</div> }
                <blockquote></blockquote>
                <div class="total group-total">{{ fmt(g.total || null) }}</div>
                <div class="row-menu"></div>
              </div>
              @if (open) {
                @for (row of g.rows; track row.row_id; let i = $index) {
                    @let ri = g.start + i;
                    @let state = rowState(row);
                    @let tip = stateTitles[state];
                    @let isOpen = form?.row_id === row.row_id;
                    @let from = row.from.home ? ('tracking.trips.home' | translate) : address(row.from);
                    @let to = row.to.home ? ('tracking.trips.home' | translate) : address(row.to);
                    <div class="calendar-project-body" [attr.data-row]="row.row_id">
                      <!-- One line per row like Hours: the route, then the note, each clipped with the full text on hover. -->
                      <div class="side" [attr.title]="from + ' → ' + to + (row.description ? '\n' + row.description : '')">
                        @if (editable) {
                          <button type="button" class="route" [id]="'route-' + row.row_id" [attr.data-route]="row.row_id"
                                  [attr.aria-expanded]="isOpen" [attr.aria-controls]="isOpen ? 'trip-editor' : null"
                                  [disabled]="!!form && !isOpen" (click)="isOpen ? tryCancel() : edit(row)">
                            <ng-container *ngTemplateOutlet="routeText; context: {$implicit: row, from, to, tip, state}"></ng-container>
                          </button>
                        } @else {
                          <div class="route"><ng-container *ngTemplateOutlet="routeText; context: {$implicit: row, from, to, tip, state}"></ng-container></div>
                        }
                        <!-- The Commute card's title already says the travel type. -->
                        @if (g.kind !== 'commute') {
                          <span class="phase-item">{{ (row.purpose === 'commute' ? 'tracking.trips.commute' : 'tracking.trips.business') | translate }}</span>
                        }
                      </div>
                      <blockquote></blockquote>
                      @for (km of row.km; track $index; let d = $index) {
                        <div class="weekday" [ngClass]="state" [attr.title]="tip ? (tip | translate) : null">
                          @if (editable) {
                            <input nbInput fieldSize="small" type="text" inputmode="decimal" autocomplete="off" class="cell-input"
                                   [attr.data-cell]="ri + '-' + d" [value]="fmt(km)"
                                   [attr.aria-label]="(days[d] | localedate:'dddd D MMMM') + ', ' + (row.to.home ? ('tracking.trips.home' | translate) : row.to.town)"
                                   [attr.aria-invalid]="cellError?.row === row.row_id && cellError?.day === d"
                                   [attr.aria-describedby]="cellError?.row === row.row_id && cellError?.day === d ? 'trip-err-cell' : null"
                                   (focus)="$any($event.target).select()"
                                   (keydown)="cellKey($event, d, row)" (change)="commitCell(row, d, $any($event.target))">
                          } @else {
                            <span class="km-text">{{ fmt(km) }}</span>
                          }
                        </div>
                      }
                      <blockquote></blockquote>
                      <div class="total">{{ fmt(total(row)) }}</div>
                      <div class="row-menu">
                        @if (editable) {
                          <button nbButton ghost size="tiny" status="basic" class="kebab" [attr.data-menu]="row.row_id" [disabled]="!!form"
                                  [nbPopover]="rowMenu" [nbPopoverContext]="row" nbPopoverPlacement="bottom" (click)="openMenu(row)"
                                  [attr.aria-label]="'tracking.trips.actions' | translate"><nb-icon icon="more-vertical"></nb-icon></button>
                        }
                      </div>
                    </div>
                    @if (isOpen) { <ng-container *ngTemplateOutlet="editor"></ng-container> }
                }
                @if (form && newIn === g.key) {
                  <ng-container *ngTemplateOutlet="draftRow"></ng-container>
                } @else if (!form && canAddTo(g)) {
                  <!-- A blank row to fill like Hours: a day box opens this card's draft on that day; the button is the keyboard way in. -->
                  <div class="calendar-project-body blank-row">
                    <div class="side calendar-add-line">
                      <button nbButton ghost size="tiny" status="basic" data-action="add-line" (click)="add(g)">
                        <nb-icon icon="plus-outline"></nb-icon>
                        <span>{{ 'tracking.trips.add' | translate }}</span>
                      </button>
                    </div>
                    <blockquote></blockquote>
                    @for (day of days; track $index; let d = $index) {
                      <div class="weekday">
                        <input nbInput fieldSize="small" type="text" readonly tabindex="-1" aria-hidden="true" class="cell-input" (click)="add(g, d)">
                      </div>
                    }
                    <blockquote></blockquote>
                    <div class="total"></div>
                    <div class="row-menu"></div>
                  </div>
                }
              }
            </div>
          }
          @if (form && newIn === 'new') {
            <div class="calendar-project new-card" data-group="new">
              <ng-container *ngTemplateOutlet="draftRow"></ng-container>
            </div>
          }
        </div>

        @if (!form && canAdd) {
          <div class="calendar-bottom">
            <ng-container *ngTemplateOutlet="copyWeek"></ng-container>
            <button nbButton status="primary" class="add" data-focus="add" (click)="add()">
              <nb-icon icon="plus-circle"></nb-icon>
              <span>{{ 'tracking.trips.add' | translate }}</span>
            </button>
          </div>
        }
      </div>
    } @else {
      <div class="phone">
        <div class="day-strip">
          @for (day of days; track $index; let d = $index) {
            <button type="button" class="day-chip" [class.selected]="d === selectedDay" [class.today]="day.isSame(today, 'day')" [attr.aria-pressed]="d === selectedDay"
                    [disabled]="!!form?.row_id" (click)="selectedDay = d"
                    [attr.aria-label]="(day | localedate:'dddd D MMMM') + (dayTotal(d) ? ', ' + fmt(dayTotal(d)) + ' km' : '')">
              <span class="chip-dow">{{ day | localedate:'dd' }}</span>
              @if (dayTotal(d)) { <span class="chip-total">{{ fmt(dayTotal(d)) }}</span> } @else { <span class="chip-dot"></span> }
            </button>
          }
        </div>
        <div class="day-nav">
          <button nbButton ghost status="basic" class="day-step" data-nav="prev-day" [disabled]="paging || !!form" (click)="stepDay(-1)"
                  [attr.aria-label]="'tracking.trips.prev_day' | translate"><nb-icon icon="arrow-ios-back-outline"></nb-icon></button>
          <div class="day-label">
            <span class="dow">{{ days[selectedDay] | localedate:'dddd' }}</span>
            <span class="date">{{ days[selectedDay] | localedate:'D MMMM' }}</span>
            @if (dayTotal(selectedDay)) { <span class="day-total num">{{ fmt(dayTotal(selectedDay)) }} km</span> }
          </div>
          <button nbButton ghost status="basic" class="day-step" data-nav="next-day" [disabled]="paging || !!form" (click)="stepDay(1)"
                  [attr.aria-label]="'tracking.trips.next_day' | translate"><nb-icon icon="arrow-ios-forward-outline"></nb-icon></button>
        </div>

        <!-- Hours' phone cards (timesheet.component.html, isMobile): one card per group, the header
             toggles it, each trip is a route line with the selected day's km and the row kebab. -->
        <div class="phone-body">
          @if (!groups.length && !form) {
            <p class="empty">{{ 'tracking.trips.empty' | translate:{week: weekNumber} }}</p>
          }
          @for (g of groups; track g.key) {
            @let title = g.kind === 'project' ? g.name : ((g.kind === 'commute' ? 'tracking.trips.commute' : 'tracking.trips.other_trips') | translate);
            @let open = !closed.has(g.key);
            <div class="phone-card" [class.open]="open" [attr.data-group]="g.key">
              <button type="button" class="phone-card-head" [attr.aria-expanded]="open" [disabled]="!!form" (click)="toggle(g.key)">
                <nb-icon class="chevron" [icon]="open ? 'arrow-down' : 'arrow-right'"></nb-icon>
                <span class="proj-dot" [style.background-color]="g.color || 'transparent'"></span>
                <span class="title-item">{{ title }}</span>
                @if (g.days[selectedDay]) { <span class="head-total">{{ fmt(g.days[selectedDay]) }}</span> }
              </button>
              @if (open) {
                @for (row of g.rows; track row.row_id; let i = $index) {
                    @let ri = g.start + i;
                    @let state = rowState(row);
                    @let tip = stateTitles[state];
                    @let isOpen = form?.row_id === row.row_id;
                    @let from = row.from.home ? ('tracking.trips.home' | translate) : address(row.from);
                    @let to = row.to.home ? ('tracking.trips.home' | translate) : address(row.to);
                    <div class="trip-card" [attr.data-row]="row.row_id">
                      @if (editable) {
                        <button type="button" class="card-route route" [id]="'route-' + row.row_id" [attr.data-route]="row.row_id"
                                [attr.aria-expanded]="isOpen" [attr.aria-controls]="isOpen ? 'trip-editor' : null"
                                [disabled]="!!form && !isOpen" (click)="isOpen ? tryCancel() : edit(row)">
                          <ng-container *ngTemplateOutlet="routeText; context: {$implicit: row, from, to, tip, state}"></ng-container>
                        </button>
                      } @else {
                        <div class="card-route"><ng-container *ngTemplateOutlet="routeText; context: {$implicit: row, from, to, tip, state}"></ng-container></div>
                      }
                      <div class="card-km" [ngClass]="state" [attr.title]="stateTitles[state] ? (stateTitles[state] | translate) : null">
                        @if (editable) {
                          <input nbInput fieldSize="small" type="text" inputmode="decimal" autocomplete="off" class="cell-input"
                                 [attr.data-cell]="ri + '-' + selectedDay" [value]="fmt(row.km[selectedDay])"
                                 [attr.aria-label]="(days[selectedDay] | localedate:'dddd D MMMM') + ', ' + (row.to.home ? ('tracking.trips.home' | translate) : row.to.town)"
                                 [attr.aria-invalid]="cellError?.row === row.row_id && cellError?.day === selectedDay"
                                 [attr.aria-describedby]="cellError?.row === row.row_id && cellError?.day === selectedDay ? 'trip-err-cell' : null"
                                 (focus)="$any($event.target).select()"
                                 (keydown)="cellKey($event, selectedDay, row)" (change)="commitCell(row, selectedDay, $any($event.target))">
                        } @else {
                          <span class="km-text">{{ fmt(row.km[selectedDay]) }}</span>
                        }
                      </div>
                      @if (editable) {
                        <button nbButton ghost size="tiny" status="basic" class="kebab" [attr.data-menu]="row.row_id" [disabled]="!!form"
                                [nbPopover]="rowMenu" [nbPopoverContext]="row" nbPopoverPlacement="bottom" (click)="openMenu(row)"
                                [attr.aria-label]="'tracking.trips.actions' | translate"><nb-icon icon="more-vertical"></nb-icon></button>
                      }
                    </div>
                    @if (isOpen) { <ng-container *ngTemplateOutlet="editor"></ng-container> }
                }
                @if (form && newIn === g.key) {
                  <ng-container *ngTemplateOutlet="phoneDraft"></ng-container>
                } @else if (!form && canAddTo(g)) {
                  <div class="calendar-add-line">
                    <button nbButton ghost size="small" status="primary" data-action="add-line" (click)="add(g)">
                      <nb-icon icon="plus-outline"></nb-icon>
                      <span>{{ 'tracking.trips.add' | translate }}</span>
                    </button>
                  </div>
                }
              }
            </div>
          }
          @if (form && newIn === 'new') {
            <div class="phone-card open new-card" data-group="new">
              <ng-container *ngTemplateOutlet="phoneDraft"></ng-container>
            </div>
          }
        </div>
        @if (!form && canAdd) {
          <button nbButton status="primary" size="large" fullWidth class="add" data-focus="add" (click)="add()">
            <nb-icon icon="plus-circle"></nb-icon>
            {{ 'tracking.trips.add_for_day' | translate:{day: (days[selectedDay] | localedate:'dddd')} }}</button>
          <ng-container *ngTemplateOutlet="copyWeek"></ng-container>
        }
      </div>
    }
    <!-- One refused-cell message for both layouts. -->
    @if (cellError) {
      <p class="error" id="trip-err-cell" role="alert">{{ days[cellError.day] | localedate:'dddd' }}: {{ 'tracking.trips.err_km_range' | translate }}</p>
    }

    <!-- The row kebab's popover (Hours' .row-menu place). It closes when the row leaves the DOM. -->
    <ng-template #rowMenu let-row>
      <div class="trip-menu">
        <button nbButton ghost size="small" status="basic" data-action="edit" [attr.data-row]="row.row_id" (click)="edit(row)">
          <nb-icon icon="edit-outline"></nb-icon><span>{{ 'tracking.trips.edit' | translate }}</span></button>
        <!-- Not with a row open: a remove must not race its Done. -->
        @if (!form) {
          <button nbButton ghost size="small" status="danger" data-action="remove" [disabled]="busy" (click)="remove(row)">
            <nb-icon icon="trash-2-outline"></nb-icon><span>{{ 'tracking.trips.remove' | translate }}</span></button>
        }
      </div>
    </ng-template>

  </div>
} @else {
  <!-- The header card carries the week arrows, so it stays while a week loads or fails to. -->
  <div class="week-trips">
    @if (!narrow) {
      <div class="calendar-block"><ng-container *ngTemplateOutlet="calHeader"></ng-container></div>
    } @else {
      <div class="day-nav">
        <button nbButton ghost status="basic" class="day-step" data-nav="prev" [disabled]="paging" (click)="paged.emit(-1)"
                [attr.aria-label]="'registration.prev_week' | translate"><nb-icon icon="arrow-ios-back-outline"></nb-icon></button>
        <div class="day-label">
          <span class="dow">{{ 'tracking.trips.week' | translate:{week: weekNumber} }}</span>
          <span class="date">{{ days[0] | localedate:'D MMM' }} - {{ days[6] | localedate:'D MMM' }}</span>
        </div>
        <button nbButton ghost status="basic" class="day-step" data-nav="next" [disabled]="paging" (click)="paged.emit(1)"
                [attr.aria-label]="'registration.next_week' | translate"><nb-icon icon="arrow-ios-forward-outline"></nb-icon></button>
      </div>
    }
    @if (loadFailed) {
      <p class="state-hint" role="alert">{{ 'tracking.trips.loadfailed' | translate }}
        <button nbButton ghost size="small" status="primary" data-action="retry" (click)="retry()">{{ 'retry' | translate }}</button>
      </p>
    }
  </div>
}

<!-- Hours header card (timesheet.component.html, desktop calendar): week label, range, arrows around the days,
     then the day totals band. -->
<ng-template #calHeader>
  <div class="calendar-header">
    <div class="calendar-dates">
      <div class="side">
        <label>{{ weekLabel | translate:{value: weekOffset < 0 ? -weekOffset : weekOffset} }}
          <span class="week-number">{{ 'tracking.trips.week' | translate:{week: weekNumber} }}</span></label>
        <label>{{ days[0] | localedate:'MMM D' }} - {{ days[6] | localedate:'MMM D, YYYY' }}</label>
      </div>
      <button nbButton outline status="basic" data-nav="prev" [disabled]="paging || !!form" (click)="paged.emit(-1)"
              [attr.aria-label]="'registration.prev_week' | translate"><nb-icon icon="arrow-left"></nb-icon></button>
      <!-- Hours' .dateadd: a day head adds a trip on that day. -->
      @for (day of days; track $index; let d = $index) {
        <div class="day-head" [class.today]="day.isSame(today, 'day')">
          <button type="button" class="day-add" [disabled]="!week || !canAdd || !!form" (click)="add(undefined, d)"
                  [attr.aria-label]="'tracking.trips.add_for_day' | translate:{day: (day | localedate:'dddd D MMMM')}">
            <span class="dow">{{ day | localedate:'ddd' }}</span>
            <span class="dates">{{ day | localedate:'MMM DD' }}</span>
          </button>
        </div>
      }
      <button nbButton outline status="basic" data-nav="next" [disabled]="paging || !!form" (click)="paged.emit(1)"
              [attr.aria-label]="'registration.next_week' | translate"><nb-icon icon="arrow-right"></nb-icon></button>
      <div class="total"><span class="col-label">{{ 'tracking.trips.total' | translate }}</span></div>
      <div class="row-menu"></div>
    </div>
    <!-- The one place the grid says its unit: every number below the header is km. -->
    <div class="calendar-overview">
      <div class="side"><span class="band-label">{{ 'tracking.trips.km_per_day' | translate }}</span></div>
      <blockquote></blockquote>
      @for (day of days; track $index; let d = $index) { <div class="day-total">{{ week ? fmt(dayTotal(d) || null) : '' }}</div> }
      <blockquote></blockquote>
      <div class="total week-total">@if (week) { {{ fmt(weekTotal) }} <span class="unit">km</span> }</div>
      <div class="row-menu"></div>
    </div>
  </div>
</ng-template>
<!-- Hours' Copy last week, in the same footer slot. -->
<ng-template #copyWeek>
  <button nbButton ghost status="basic" class="copy-week" data-action="copy-week" [disabled]="busy" (click)="copyLastWeek()"
          [nbTooltip]="'tracking.trips.copylastweekhint' | translate">
    <nb-icon icon="copy-outline"></nb-icon>
    <span>{{ 'tracking.trips.copylastweek' | translate }}</span>
  </button>
</ng-template>

<!-- The route text, shared by the button (editable) and the plain text (read-only), desktop and phone. -->
<ng-template #routeText let-row let-from="from" let-to="to" let-tip="tip" let-state="state">
  <span class="route-line">{{ from }} &rarr; {{ to }}</span>
  <!-- The cells' colour and hover title, for a screen reader and a touch screen; the chip already says Invoiced. -->
  @if (tip && state !== 'st-inv') { <span class="visually-hidden">{{ tip | translate }}</span> }
  @if (row.description || row.invoiced) {
    <span class="route-note">
      @if (row.invoiced) { <span class="status-chip invoiced">{{ invoicedLabel(row) | translate:{count: row.invoiced} }}</span> }
      {{ row.description }}</span>
  }
</ng-template>

<!-- The open row's editor (spec 2026-10-13): directly under its row, named by the route button or the draft row. -->
<ng-template #editor>
  <div class="row-editor" id="trip-editor" role="region" [attr.aria-labelledby]="form.row_id ? 'route-' + form.row_id : 'new-trip-title'"
       (keydown)="editorKey($event)">
    <section class="editor-body">
      @if (!week.home?.street) {
        <p class="state-hint"><a routerLink="/users/me">{{ 'tracking.trips.nohome' | translate }}</a></p>
      }
      @for (end of ['from', 'to']; track end) {
        <span class="field end" [class.has-error]="!!errors[end]" [attr.data-focus]="end" tabindex="-1" role="group"
              [attr.aria-label]="('tracking.trips.' + end) | translate" [attr.aria-describedby]="errors[end] ? 'trip-err-' + end : null">
          <span class="field-label" aria-hidden="true">{{ ('tracking.trips.' + end) | translate }}</span>
          <bst-trip-end [legend]="'tracking.trips.' + end" [home]="week.home" [(ngModel)]="form[end]"></bst-trip-end>
          @if (errors[end]) { <span class="error" [id]="'trip-err-' + end">{{ errors[end] | translate }}</span> }
        </span>
      }
      <span class="field">
        <label class="field-label" for="trip-desc">{{ 'tracking.trips.description' | translate }}</label>
        <input nbInput fieldSize="small" fullWidth id="trip-desc" maxlength="250" [(ngModel)]="form.description">
      </span>
      <!-- nb-select's host takes no focus, so the wrapper is what save() focuses when invalid. -->
      <span class="field project" [class.has-error]="!!errors.project" data-focus="project" tabindex="-1" role="group"
            [attr.aria-label]="'tracking.trips.trip_for' | translate" [attr.aria-describedby]="errors.project ? 'trip-err-project' : null">
        <span class="field-label" aria-hidden="true">{{ 'tracking.trips.trip_for' | translate }}</span>
        <nb-select size="small" fullWidth [status]="errors.project ? 'danger' : 'basic'" [ngModel]="choice" (ngModelChange)="choose($event)"
                   [placeholder]="'tracking.trips.project' | translate" [attr.aria-label]="'tracking.trips.trip_for' | translate"
                   [attr.aria-invalid]="!!errors.project" [attr.aria-describedby]="errors.project ? 'trip-err-project' : null">
          <nb-option value="commute">{{ 'tracking.trips.commute' | translate }}</nb-option>
          @for (p of projectOptions; track p.id) { <nb-option [value]="p.id">{{ p.name }}</nb-option> }
        </nb-select>
        @if (!week.projects.length) {
          <span class="state-hint">{{ 'tracking.trips.noprojects' | translate:{week: weekNumber} }}</span>
        }
        @if (errors.project) { <span class="error" id="trip-err-project">{{ errors.project | translate }}</span> }
      </span>
    </section>
    <footer class="editor-bar">
      @if (!form.row_id) {
        <nb-checkbox [(ngModel)]="form.return">{{ 'tracking.trips.return' | translate }}</nb-checkbox>
        <span class="hint">{{ 'tracking.trips.preview' | translate:{routes: preview.routes, days: preview.days, km: fmt(preview.km)} }}</span>
      }
      @if (errors.km) { <span class="error" id="trip-err-km" role="alert">{{ errors.km | translate }}</span> }
      @if (errors.row) { <span class="error" role="alert">{{ errors.row | translate }}</span> }
      <span class="spacer"></span>
      <span class="actions">
        <button nbButton ghost size="small" type="button" data-action="cancel" (click)="tryCancel()">{{ 'cancel' | translate }}</button>
        <button nbButton size="small" type="button" status="primary" data-action="submit" [nbSpinner]="savingForm" nbSpinnerStatus="control" nbSpinnerSize="tiny" [attr.aria-busy]="savingForm" (click)="save()">{{ 'tracking.trips.done' | translate }}</button>
      </span>
    </footer>
  </div>
</ng-template>

<!-- A new trip on the desktop grid: its seven km are a draft until Done (storeRow needs at least one). -->
<ng-template #draftRow>
  <div class="calendar-project-body draft-row" (keydown)="editorKey($event)">
    <div class="side"><span class="route new-trip" id="new-trip-title">{{ 'tracking.trips.new_trip' | translate }}</span></div>
    <blockquote></blockquote>
    @for (day of days; track $index; let d = $index) {
      <div class="weekday st-draft">
        <input nbInput fieldSize="small" type="text" inputmode="decimal" autocomplete="off" class="cell-input km"
               [attr.data-cell]="'draft-' + d" [(ngModel)]="form.km[d]"
               [attr.aria-label]="(day | localedate:'dddd D MMMM') + ', ' + ('tracking.trips.km' | translate)"
               [attr.aria-invalid]="!!errors.km" [attr.aria-describedby]="errors.km ? 'trip-err-km' : null"
               (focus)="$any($event.target).select()" (keydown)="cellKey($event, d)">
      </div>
    }
    <blockquote></blockquote>
    <div class="total">{{ fmt(draftTotal || null) }}</div>
    <div class="row-menu"></div>
  </div>
  <ng-container *ngTemplateOutlet="editor"></ng-container>
</ng-template>

<!-- A new trip on the phone: one km box for the selected day; the day chips switch which of the seven drafts it shows. -->
<ng-template #phoneDraft>
  <div class="trip-card draft-row" (keydown)="editorKey($event)">
    <div class="card-route"><span class="route-line new-trip" id="new-trip-title">{{ 'tracking.trips.new_trip' | translate }}</span></div>
    <div class="card-km st-draft">
      <input nbInput fieldSize="small" type="text" inputmode="decimal" autocomplete="off" class="cell-input km"
             [attr.data-cell]="'draft-' + selectedDay" [(ngModel)]="form.km[selectedDay]"
             [attr.aria-label]="(days[selectedDay] | localedate:'dddd D MMMM') + ', ' + ('tracking.trips.km' | translate)"
             [attr.aria-invalid]="!!errors.km" [attr.aria-describedby]="errors.km ? 'trip-err-km' : null"
             (focus)="$any($event.target).select()">
    </div>
  </div>
  <ng-container *ngTemplateOutlet="editor"></ng-container>
</ng-template>
<div class="visually-hidden" aria-live="polite">{{ announcement | translate }}</div>
